export default __webpack_public_path__ + "static/media/phone.756279cb.png";